export const filtersToUrl = (filters, page = 1) => {

  let segments = [];
  let query = {content_type: "json"};

  filters.forEach(function (filter) {
    if (filter.filter.values.max) {
      query["max_" + filter.filter.slug] = filter.filter.values.max;
    }

    if (filter.filter.values.min) {
      query["min_" + filter.filter.slug] = filter.filter.values.min;
    }

    if (filter.filter.values[0]) {
      segments.push(filter.filter.slug
        + "-"
        + filter.filter.values.sort().join("-" + filter.filter.logic + "-"));
    }
  });

  if (page > 1) {
    segments.unshift("page/" + page);
  }

  return "https://wp.colorissimo.com/shop/"
    + (segments.length ? segments.join("/") + "/" : "")
    + "?"
    + optionsToQueryParams(query);
};

export const buildAppUrl = (filters, page = 1) => {
  let old = Array.from(new URLSearchParams(window.location.search))
    .filter(a => {
      return !(a[0].startsWith('max_')
        || a[0].startsWith('min_')
        || a[0].startsWith('filter_')
        || a[0] == 'page')
    });

  let params = {};
  filters.forEach(function (item) {
    const values = item.filter.values;
    const slug = item.filter.slug;

    if (values.max) {
      params['max_' + slug] = values.max;
    }

    if (values.min) {
      params['min_' + slug] = values.min;
    }

    if (values[0]) {
      params['filter_' + slug] = values
        .sort()
        .join("-" + item.filter.logic + "-");
    }
  });

  if (page > 1) {
    params["page"] = page.toString();
  } else {
    delete params.page;
  }

  old.forEach((row) => {
    params[row[0]] = row[1];
  })

  return params;
};

export const optionsToQueryParams = (options) => {
  const params = new URLSearchParams("");

  for (let option in options) {
    if (options[option]) {
      params.set(option, options[option].toString());
    }
  }

  return params.toString();
};

export const buildWooUrl = (params, page = "1", count = null, sorting = null) => {
  let segments = [];
  let query = {content_type: "json"};

  for (key in params) {
    if (key.indexOf("min_") === 0 || key.indexOf("max_") === 0) {
      query[key] = params[key];
    }

    if (key.indexOf("filter_") === 0) {
      segments.push(key.slice(7) + "-" + params[key]);
    }
  }

  if (page > 1) {
    segments.unshift("page/" + page);
  }

  return "https://wp.colorissimo.com/shop/"
    + (segments.length ? segments.join("/") + "/" : "")
    + "?"
    + optionsToQueryParams(query);
};